module.exports = __webpack_public_path__ + "img/img_throw_2@3x_v3.44b366bd.png";